import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { APIApartmentItem, MarketTypes } from 'api/types';
import { ApartmentDeal } from './use-apartment-deals';

const useApartmentSaleAds = (fetch = true, marketType = MarketTypes.PRIMARY) => {
  const { data, error, isLoading } = useSWR(
    fetch && `/facilities?marketType=${marketType}`,
    (url: string) =>
      fetcher.swr<{ facilities: APIApartmentItem[] }>(url).then((res) =>
        res.facilities.map<ApartmentDeal>((i) => ({
          id: i.id,
          area: i.areaInSqM,
          housingEstate: i.apartmentComplexTitle,
          rooms: i.roomCount,
          image: i.planImage ?? undefined,
          attachment: i.attachment ?? undefined,
          squarePrice: i.pricePerSqM,
          price: i.price,
          floor: { floor: i.floor, total: i.floorCount },
          availabilityStatus: i?.availabilityStatus,
          buildingTitle: i?.buildingTitle,
        })),
      ),
  );

  return { apartments: data ?? [], error, isLoading };
};

export default useApartmentSaleAds;
